(() => {
  const root = document.querySelector('[data-flocked-catalogue]');
  if (!root) return;
  const search = root.querySelector('[data-flocked-search]');
  const kind = root.querySelector('[data-flocked-kind]');
  const count = root.querySelector('[data-flocked-count]');
  const empty = root.querySelector('[data-flocked-empty]');
  const cards = Array.from(root.querySelectorAll('[data-flocked-code]'));
  const update = () => {
    const term = search.value.trim().toLocaleLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const show = (!term || card.dataset.search.toLocaleLowerCase().includes(term)) && (!kind.value || card.dataset.kind === kind.value);
      card.hidden = !show;
      if (show) visible++;
    });
    count.textContent = count.dataset.template.replace('{count}', String(visible));
    empty.hidden = visible !== 0;
  };
  const revealHash = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    const card = cards.find(item => item.id === id);
    if (!card) return;
    search.value = '';
    kind.value = '';
    update();
    const details = card.querySelector('details');
    if (details) details.open = true;
    requestAnimationFrame(() => card.scrollIntoView({block: 'start'}));
  };
  search.addEventListener('input', update);
  kind.addEventListener('change', update);
  window.addEventListener('hashchange', revealHash);
  update();
  revealHash();
})();
